import loveDcb from '@/utils/love'
import { dcb } from '@dcb/jssdk'
import { GeoCoord } from 'vtils'
import { globalModel } from '@/model'
import { showActionSheet } from './show_action_sheet'
import { wechat } from '@/wechat'

export function openMap(data: {
  /** 名称 */
  name?: string
  /** 经度 */
  longitude: number
  /** 纬度 */
  latitude: number
}) {
  if (globalModel.state.inAlipay) {
    dcb.openLocation({
      name: data.name || '目的地',
      address: data.name || '目的地',
      longitude: data.longitude,
      latitude: data.latitude,
    })
  } else if (globalModel.state.inYancheng) {
    const { longitude, latitude } = GeoCoord.BD09ToGCJ02({
      longitude: data.longitude,
      latitude: data.latitude,
    })
    // @ts-ignore
    sc.openLocation({
      name: data.name || '',
      longitude: longitude,
      latitude: latitude,
      address: '',
    })
  } else if (globalModel.state.inLove) {
    const { longitude, latitude } = GeoCoord.BD09ToGCJ02({
      longitude: data.longitude,
      latitude: data.latitude,
    })
    loveDcb.openThirdMap({
      longitude: longitude,
      latitude: latitude,
      name: data.name || '目的地',
    })
  } else if (globalModel.state.inWechatWebView) {
    const { longitude, latitude } = GeoCoord.BD09ToGCJ02({
      longitude: data.longitude,
      latitude: data.latitude,
    })
    wechat.openLocation({
      longitude: longitude,
      latitude: latitude,
      name: data.name || '目的地',
    })
  } else {
    showActionSheet([
      {
        label: '高德地图',
        onClick: () => {
          const { longitude, latitude } = GeoCoord.BD09ToGCJ02({
            longitude: data.longitude,
            latitude: data.latitude,
          })
          // https://lbs.amap.com/api/amap-mobile/guide/android/navigation
          // 坐标已经转换过，dev 必须设为 0
          const androidUrl = `androidamap://navi?sourceApplication=appname&lat=${latitude}&lon=${longitude}&dev=0&style=2`
          const iosUrl = `iosamap://navi?sourceApplication=appname&lat=${latitude}&lon=${longitude}&dev=0&style=2`
          const hosUrl = `amapuri://route/plan?dlat=${latitude}&dlon=${longitude}&dname=${data.name}&t=0`
          dcb.navigateToApp({
            androidUrl,
            iosUrl,
            hosUrl,
            failTip: '打开失败，你可能未安装高德地图',
          })
        },
      },
      {
        label: '百度地图',
        onClick: () => {
          const androidUrl = `baidumap://map/navi?location=${data.latitude},${data.longitude}&src=andr.baidu.openAPIdemo`
          const iosUrl = androidUrl
          const hosUrl = `baidumap://map/direction?destination=latlng:${data.latitude},${data.longitude},|name:${data.name}&mode=driving`
          dcb.navigateToApp({
            androidUrl,
            iosUrl,
            hosUrl,
            failTip: '打开失败，你可能未安装百度地图',
          })
        },
      },
    ])
  }
}
